import React from 'react'

import { BuilderIdContext } from 'common/builder/components/builder/BuilderIdProvider/BuilderIdProvider'
import { FieldsSelector, useFlowFields } from 'common/builder/hooks/useFlowFields'
import MCTextViewer, { MCTextViewerLegacyProps } from 'components/MCTextEditor/viewer'

type FlowTextEditorProps = Omit<MCTextViewerLegacyProps, 'getFields'> & {
  fieldsSelector?: FieldsSelector
}

const FlowTextViewer = ({ fieldsSelector, ...props }: FlowTextEditorProps) => {
  const fields = useFlowFields(fieldsSelector)
  const builderId = React.useContext(BuilderIdContext)?.builderId

  return <MCTextViewer {...props} builderId={builderId} getFields={() => fields} />
}

export default FlowTextViewer
